import { Formik } from "formik";
import { FunctionComponent, useContext, useState } from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { handleConvertAddress } from "src/app/modules/utils/AppFunction";
import {CODE} from "src/app/modules/utils/Constant";
import { formatBirthdate, formatDateTime, getErrorMessage } from "src/app/modules/utils/FormatUtils";
import { PhanHeTiepDonContext } from "../contexts/PhanHeTiepDonContext";
import PageChiDinhDichVu from "../modals/modal-chi-dinh-dich-vu/PageChiDinhDichVu";
import PageKeThuoc from "../modals/modal-ke-thuoc/PageKeThuoc";
import PageKeVatTu from "../modals/modal-ke-vat-tu/ModalKeVatTu";
import CapToaChoVeModal from "../modals/modal-tab-xu-tri/ModalCapToaChoVe";
import ModalChuyenTuyenVien from "../modals/modal-tab-xu-tri/ModalChuyenTuyenVien";
import PageThanhToan from "../modals/modal-thanh-toan/ModalThanhToan";
import ThongTinChiPhi from "./ThongTinChiPhi";
import { formatPatientRowData } from "../utils/Utils";
import { cancelBenhAnNgoaiTru } from "../services/KhamBenhService";
import { AppContext } from "src/app/modules/appContext/AppContext";
import { toast } from "react-toastify";
import ModalEditOneColumn from "./modal-ke-thuoc/ModalEditOneColumn";
import {OctKTSVG} from "@oceantech/oceantech-ui";
import ModalBenhAnNoiTru from "../modals/modal-benh-an";
import EMedicalRecordButton from "./e-medical-record-button";

interface ThongTinBenhNhanProps {
}

const initialValues = {};

const ThongTinBenhNhan: FunctionComponent<ThongTinBenhNhanProps> = (props) => {
  const { benhNhanInfo, setBenhNhanInfo, statusChangedEventFunc } = useContext(PhanHeTiepDonContext);
  const { setIsLoading } = useContext(AppContext);

  const [openCapNhatMauChiDinhDialog, setOpenCapNhatMauChiDinhDialog] = useState<boolean>(false);
  const [shouldOpenChiDinhDichVuModal, setShouldOpenChiDinhDichVuModal] = useState<boolean>(false);
  const [shouldOpenCapToaModal, setShouldOpenCapToaModal] = useState<boolean>(false);
  const [shouldOpenChuyenVienModal, setShouldOpenChuyenVienModal] = useState<boolean>(false);
  const [shouldOpenModalKeVatTu, setShouldOpenModalKeVatTu] = useState<boolean>(false);
  const [shouldOpenModalThanhToan, setShouldOpenModalThanhToan] = useState<boolean>(false);
  const [isFunctionalFoods, setIsFunctionalFoods] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [shouldOpenModalBenhAn, setShouldOpenModalBenhAn] = useState<boolean>(false);

  const { patient, visit, encounterDiagnosis, encounter } = benhNhanInfo?.thongTinKhamBenh ?? {};

  const updatePatientInfo = () => {
    setBenhNhanInfo({
      ...benhNhanInfo,
      updateTab: !benhNhanInfo.updateTab,
    });
    statusChangedEventFunc?.();
  };

  const onHuyBenhAnNgoaiTru = async (deletedReason: string) => {
    try {
      setIsLoading(true);
      const response = await cancelBenhAnNgoaiTru({
        orderId: benhNhanInfo?.thongTinKhamBenh?.orderId,
        deletedReason,
      });

      if (CODE.SUCCESS !== response.code) {
        toast.error(getErrorMessage(response));
        return;
      }

      toast.success("Hủy bệnh án thành công");
      updatePatientInfo();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getMedicalConclusionModality = () => {
    if (encounterDiagnosis?.medicalConclusionModalityName) {
      return encounterDiagnosis.medicalConclusionModalityName + ' - ';
    }
    return '';
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
    setOpenCapNhatMauChiDinhDialog(false);
    setShouldOpenModalBenhAn(false);
    setShouldOpenChiDinhDichVuModal(false);
    setShouldOpenCapToaModal(false);
    setShouldOpenChuyenVienModal(false);
    setShouldOpenModalKeVatTu(false);
    setShouldOpenModalThanhToan(false);
  }

  return (
    <>
      <Formik<any> initialValues={initialValues} onSubmit={() => {}}>
        <div className="bg-white mb-2">
          <div className="d-flex justify-content-start align-items-center spaces h-38 py-4">
            <div className=" justify-content-start pl-4 spaces d-flex gap-4">
              {benhNhanInfo?.thongTinKhamBenh?.id && (
                <>
                  <Button
                    className="btn-fill"
                    onClick={() => setShouldOpenModalBenhAn(true)}
                  >
                    Bệnh án
                  </Button>
                  <EMedicalRecordButton 
                    params={{
                      medicalRecordCode: encounter?.medicalRecordCode
                    }}
                  />
                </>
              )}
              {benhNhanInfo?.thongTinKhamBenh?.isExamined && (
                <>
                  {!benhNhanInfo?.thongTinKhamBenh?.isConclusion && (
                    <Button
                      className="btn-fill btn-kham-benh min-w-120 spaces mx-3"
                      onClick={() => setShouldOpenChiDinhDichVuModal(true)}
                    >
                      Chỉ định DV
                    </Button>
                  )}
                  <Dropdown className="dropdown-btn menu-icon" drop="down">
                    <Dropdown.Toggle className="btn-fill spaces min-w-120">
                      <span>Kê thuốc</span>
                      <i className="bi bi-caret-down-fill spaces pl-4 pr-0 mr-0 pt-2"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="dropdown-actions">
                      <Dropdown.Item
                        onClick={() => {
                          setIsFunctionalFoods(false);
                          setOpenCapNhatMauChiDinhDialog(true);
                        }}
                      >
                        <div className="ps-5 spaces line-height-30">
                          Kê đơn thuốc
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setIsFunctionalFoods(true);
                          setOpenCapNhatMauChiDinhDialog(true);
                        }}
                      >
                        <div className="ps-5 spaces line-height-30">
                          Kê đơn thực phẩm chức năng
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Button
                    className="btn-fill btn-kham-benh min-w-120 spaces mx-3"
                    onClick={() => setShouldOpenModalKeVatTu(true)}
                  >
                    <span>Kê vật tư</span>
                  </Button>
                </>
              )}
            </div>
          </div>
          <Row className="spaces h-38 px-9 pt-4">
            <Col className="border spaces py-5" xs={4}>
              <h4 className="text-pri fs-4 fw-bold mb-0">Thông tin chi phí</h4>
            </Col>
            <Col className="border spaces py-5" xs={8}>
              <h4 className="text-pri fs-4 fw-bold mb-0">Thông tin bệnh nhân</h4>
            </Col>
          </Row>
          <Row className="spaces px-9">
            <Col className="border spaces py-5" xs={4}>
              <ThongTinChiPhi />
            </Col>
            <Col className="border spaces py-5" xs={8}>
              <Row>
                <Col xs="12">
                  <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-100 fw-bold">
                      Bệnh nhân:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {patient?.personName
                        ? formatPatientRowData([
                            patient?.code,
                            patient?.personName,
                            patient?.gender,
                            formatBirthdate({ day: patient?.dobDay, month: patient?.dobMonth, year: patient?.dobYear, ageText: patient?.ageText }),
                            visit?.visitObjectTypeName,
                            visit?.code,
                          ])
                        : '...'}
                    </span>
                  </div>
                </Col>
                <Col xs="12">
                  <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-100 fw-bold">
                      Thời điểm tới:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {visit?.dateStarted
                        ? formatDateTime(visit?.dateStarted)
                        : '...'}
                    </span>
                  </div>
                </Col>
                <Col xs={7}>
                  <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-100 fw-bold">
                      Địa chỉ:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {handleConvertAddress(patient) || '...'}
                    </span>
                  </div>
                </Col>
                <Col xs={5}>
                   <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-50 fw-bold">
                      Khoa:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {visit?.currDeptName || '...'}
                    </span>
                  </div>     
                </Col>

                <Col xs="7">
                  <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-100 fw-bold">
                      Chẩn đoán:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {benhNhanInfo?.thongTinKhamBenh?.isConclusion &&
                      encounterDiagnosis?.icdXPrimary
                        ? encounterDiagnosis?.icdXPrimaryName
                        : '...'}
                    </span>
                  </div>
                </Col>
                <Col xs="5">
                  <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-50 fw-bold">
                      Xử trí:
                    </span>
                    <span className="spaces fw-4 text-truncate">
                      {benhNhanInfo?.thongTinKhamBenh?.isConclusion
                        ? `${getMedicalConclusionModality()} 
                        ${encounterDiagnosis?.medicalConclusionName || ''}`
                        : '...'}
                    </span>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {openCapNhatMauChiDinhDialog && (
            <PageKeThuoc
              open={openCapNhatMauChiDinhDialog}
              handleClose={() => {
                setOpenCapNhatMauChiDinhDialog(false);
              }}
              onSave={() => {
                updatePatientInfo();
                setOpenCapNhatMauChiDinhDialog(false);
              }}
              isFunctionalFoods={isFunctionalFoods}
              generalInfo={benhNhanInfo?.thongTinKhamBenh}
            />
          )}

          {shouldOpenModalKeVatTu && (
            <PageKeVatTu
              open={shouldOpenModalKeVatTu}
              handleClose={() => {
                setShouldOpenModalKeVatTu(false);
              }}
              onSave={() => {
                updatePatientInfo();
              }}
              generalInfo={benhNhanInfo?.thongTinKhamBenh}
            />
          )}

          {shouldOpenChiDinhDichVuModal && (
            <PageChiDinhDichVu
              show={shouldOpenChiDinhDichVuModal}
              handleClose={() => {
                setShouldOpenChiDinhDichVuModal(false);
              }}
            />
          )}

          {shouldOpenCapToaModal && (
            <CapToaChoVeModal
              open={shouldOpenCapToaModal}
              handleCloseModal={() => setShouldOpenCapToaModal(false)}
              handleSubmit={() => {}}
            />
          )}

          {shouldOpenChuyenVienModal && (
            <ModalChuyenTuyenVien
              open={shouldOpenChuyenVienModal}
              handleCloseModal={() => setShouldOpenChuyenVienModal(false)}
              handleSubmit={() => {}}
            />
          )}

          {shouldOpenModalThanhToan && (
            <PageThanhToan
              open={shouldOpenModalThanhToan}
              handleClose={() => {
                setShouldOpenModalThanhToan(false);
              }}
            />
          )}

          {openDeleteDialog && (
            <ModalEditOneColumn
              name="Lý do hủy bệnh án"
              code="deletedReason"
              handleClose={() => setOpenDeleteDialog(false)}
              handleSave={(reason: string) => onHuyBenhAnNgoaiTru(reason)}
            />
          )}
        </div>
      </Formik>

      {shouldOpenModalBenhAn && (
        <ModalBenhAnNoiTru
          open={shouldOpenModalBenhAn}
          onClose={handleCloseDialog}
          patientInfo={benhNhanInfo}
        />
      )}
    </>
  );
};

export default ThongTinBenhNhan;
